<app-modal-header
  (close)="close()"
  [highlighted]="true">
  <span slot="title">
    {{ 'admin.lecturers-picker-modal.title' | translate }}
  </span>

  <div slot="undercontent" class="relative pb-5" >
    <div style="max-height: 35vh; overflow: auto;">
  
      @if (!fetching) {
  
        @if (selectedLecturersFC.value.length === 0) {
          <p class="p-error mb-0">
            {{ 'admin.lecturers-picker-modal.no-set-lecturers.label' | translate}}
          </p>
        } @else {
          <p class="text-green-500 mb-1">
            {{ 'admin.lecturers-picker-modal.selected-lecturers.label' | translate}}
          </p>
        }

        @for (lecturer of availableLecturersSelected; track lecturer; let first = $first; let last = $last) {
          <div
            class="surface-border surface-section border-1 flex align-items-center "
            [class.border-top-none]="!first"
            [class.border-round-top]="first"
            [class.border-round-bottom]="last">
            <app-si-lecturer-item
              [lecturer]="lecturer"
              [orgId]="orgId"
              [selected]="selectedLecturersFC.value.includes(lecturer.id)"
              (selectionChange)="onSelectionChange($event)"
              class="flex-1">
            </app-si-lecturer-item>
          </div>
        }
    
        <div class="w-full absolute z-1" style="bottom: -2rem;">
          @if (showFirstLecturerInterface) {
            <input
              type="text"
              pInputText
              [formControl]="firstLecturerFC"
              [placeholder]="'admin.lecturers-picker-modal.first-lecturer-input.label' | translate"
              class="focus-input w-full" />
          } @else {
            <div class="p-input-icon-left w-full">
              <i class="pi pi-search"></i>
              <input
                type="text"
                pInputText
                [formControl]="searchFC"
                [placeholder]="'admin.lecturers-picker-modal.search-lecturer-input.label' | translate"
                class="focus-input w-full" />
            </div>
          }
        </div>
      }    

    </div>

  </div>

</app-modal-header>

<div class="modal-body">

  <!-- spacer bcs shifted search input -->
  <div class="pt-5"></div>

  @if (fetching) {
    <div class="flex justify-content-center align-items-center">
      <p-progressSpinner></p-progressSpinner>
    </div>
  } @else {


    @if (showFirstLecturerInterface) {
      <!-- add first lecturer -->
      <div class="surface-border border-1 p-3 flex align-items-center gap-3 border-round-top" [class.border-round-bottom]="firstLecturerFC.value.length === 0">
        <p class="m-0 mb-1 text-sm">
          {{ 'admin.lecturers-picker-modal.no-lecturers-label' | translate }}
        </p>
      </div>
      @if (firstLecturerFC.value.length > 0) {
        <div (click)="onAddFirstLecturer()" class="surface-border border-1 p-3 flex align-items-center gap-3 cursor-pointer hover:surface-hover border-top-none border-round-bottom">
          <i class="pi pi-plus"></i>
      
          {{ 'admin.lecturers-picker-modal.create-new-lecturer.label' | translate }}
          "{{ firstLecturerFC.value }}"
        </div>
      }
    } @else {
      <div class="flex justify-content-between align-items-center text-bluegray-400 text-xs">
        <span>
          {{ 'admin.lecturers-picker-modal.available-lecturers.label' | translate }}
        </span>
  
        <div class="details-block-wrap text-xs">
          <span (click)="onAddLecturer()" class="detail-block">
            <span class="cursor-pointer hover:underline">
              {{ 'admin.lecturers-picker-modal.new-lecturer.label' | translate }}
            </span>
          </span>
        </div>
      </div>

      @for (lecturer of availableLecturersUnselected | searchFilter:searchFC.value:(orgId || null); track lecturer; let first = $first; let last = $last) {
        <div
          class="surface-border surface-section border-1 flex align-items-center "
          [class.border-top-none]="!first"
          [class.border-round-top]="first"
          [class.border-round-bottom]="last">
          <app-si-lecturer-item
            [lecturer]="lecturer"
            [orgId]="orgId"
            [selected]="selectedLecturersFC.value.includes(lecturer.id)"
            (selectionChange)="onSelectionChange($event)"
            class="flex-1">
          </app-si-lecturer-item>
        </div>
      }

    }
  }

</div>

<div class="modal-footer">
  <button
    (click)="close()"
    pButton
    label="{{'admin.lecturers-picker-modal.cancel-btn.label' | translate }}"
    class="p-button-sm p-button-plain p-button-text flex-1">
  </button>

  <button
    [loading]="saving"
    [disabled]="saving"
    (click)="onSubmit()"
    pButton
    label="{{'admin.lecturers-picker-modal.save-btn.label' | translate:{cnt: selectedLecturersFC.value.length} }}"
    class="p-button-sm flex-1">
  </button>
</div>